/**
 * enforce-min-quantity-fabric.js
 *
 * Ensures Fabric products cannot be added to the cart unless at least 2 units are selected,
 * unless the product already exists in the cart.
 *
 * - Targets the quantity <input> and submit <button> using section ID.
 * - Only applies this restriction for products with type "Fabric".
 */

document.addEventListener('DOMContentLoaded', function () {
  const productForm = document.querySelector('product-form');

  if (!productForm) return;

  const sectionId = productForm.dataset.sectionId;
  const productType = productForm.dataset.productType;

  if (productType !== 'Fabric') return;

  const quantityInput = document.querySelector(`#Quantity-${sectionId}`);
  const submitButton = document.querySelector(`#ProductSubmitButton-${sectionId}`);

  if (!quantityInput || !submitButton) return;

  /**
   * Checks if the fabric product is already in the cart.
   * Returns a Promise<boolean>.
   */
  function isFabricAlreadyInCart(variantId) {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        return cart.items.some(item => item.id === parseInt(variantId, 10));
      })
      .catch(() => false);
  }

  function updateButtonState(alreadyInCart) {
    const quantity = parseInt(quantityInput.value || '0', 10);
    const allowSingle = alreadyInCart;
    const shouldEnable = quantity >= 2 || (allowSingle && quantity >= 1);

    submitButton.disabled = !shouldEnable;
    submitButton.setAttribute('aria-disabled', !shouldEnable);
    submitButton.classList.toggle('disabled', !shouldEnable);
  }

  const variantInput = document.querySelector('input[name="id"]');
  const variantId = variantInput ? variantInput.value : null;

  if (!variantId) return;

  isFabricAlreadyInCart(variantId).then((alreadyInCart) => {
    updateButtonState(alreadyInCart);

    quantityInput.addEventListener('input', () => updateButtonState(alreadyInCart));
    quantityInput.addEventListener('change', () => updateButtonState(alreadyInCart));
  });
});